import { useMemo, useState } from "react";
import { StorefrontEmbedFilters } from "./storefront-embed-filters";
import {
  DEFAULT_FILTERS,
  type EmbedFilters,
  type EmbedShop,
  isInScope,
  matchesFilters,
} from "./storefront-embed-row-filter";
import { StorefrontEmbedShopRow } from "./storefront-embed-shop-row";
import { summarize } from "./storefront-embed-summary";
import { StorefrontEmbedSummaryBar } from "./storefront-embed-summary-bar";
import { useStorefrontEmbedAudits } from "./use-storefront-embed-audits";

// Only shops in scope are fetched: test and inactive shops cost nothing until included.
export function StorefrontEmbedTab({ shops }: { shops: EmbedShop[] }) {
  const [filters, setFilters] = useState<EmbedFilters>(DEFAULT_FILTERS);

  const scopedShops = useMemo(
    () => shops.filter((shop) => isInScope(shop, filters)),
    [shops, filters],
  );
  const { audits, failedIds, settledCount } = useStorefrontEmbedAudits(
    scopedShops.map((shop) => shop.id),
  );

  const summary = summarize(
    scopedShops.flatMap((shop) => audits.get(shop.id) ?? []),
  );
  const rows = scopedShops
    .map((shop) => ({ shop, audit: audits.get(shop.id) }))
    .filter((row) => matchesFilters(row, filters));

  return (
    <div className="space-y-4">
      <StorefrontEmbedSummaryBar
        summary={summary}
        settledCount={settledCount}
        totalShops={scopedShops.length}
      />
      <StorefrontEmbedFilters filters={filters} onChange={setFilters} />
      <div className="overflow-x-auto rounded-lg border bg-background">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b bg-muted/40 text-left text-xs font-medium uppercase tracking-wide text-muted-foreground">
              <th className="px-3 py-2">Shop</th>
              <th className="px-3 py-2">App embed</th>
              <th className="px-3 py-2">Script tags Baback</th>
              <th className="px-3 py-2">Vérifié</th>
              <th className="px-3 py-2">Actions</th>
            </tr>
          </thead>
          <tbody>
            {rows.map(({ shop, audit }) => (
              <StorefrontEmbedShopRow
                key={shop.id}
                shop={shop}
                audit={audit}
                hasLoadFailed={failedIds.has(shop.id)}
              />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
